import styled from 'styled-components'
import { EditIcon } from '../Icons'

export default styled(EditIcon)`
  font-size: 14px;
  color: ${props => props.theme.table.editButtonColor};
`
